
import { Vue, Component, Prop } from "vue-property-decorator";

interface HTMLInputEvent extends Event {
  target: HTMLInputElement & EventTarget;
}

interface HTMLKeypressEvent extends Event {
  keyCode: number;
}

@Component
export default class FormInput extends Vue {
  @Prop({ type: String, default: undefined }) readonly id?: string;
  @Prop({ type: [String, Number], default: undefined }) readonly value?:
    | string
    | number;
  @Prop({ type: String, default: undefined }) readonly name?: string;
  @Prop({ type: String, default: "false" }) readonly allowDecimal?: string;
  @Prop({ type: String, default: undefined }) readonly height?: string;
  @Prop({ type: String, default: "text" }) readonly type!: string;
  @Prop({ type: Boolean, default: false }) readonly invalid!: boolean;
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;
  @Prop({ type: String, default: "bg-white" }) readonly inputClass!: string;

  get isNumber(): boolean {
    return this.type === "number";
  }

  checkSymbol(event: HTMLKeypressEvent): void {
    if (this.isNumber && (event.keyCode < 48 || event.keyCode > 57)) {
      event.preventDefault();
    }
  }
  onInput(event: HTMLInputEvent): void {
    let value = event.target.value;
    if (this.isNumber) {
      if (Number(value) > 0) {
        this.$emit("input", value);
      }
    } else {
      this.$emit("input", value);
    }
  }

  get classes(): object {
    return {
      "h-9": this.height === "sm",
      customHeight: this.height === "lg",
      "h-input": !this.height,
      "focus:border-primary": !this.invalid && !this.inputClass,
      "border-red-300 text-red-900 placeholder-red-300 focus:border-red-300":
        this.invalid,
      [this.inputClass]: true,
    };
  }
}
